<template>
  <div>
    <b-row>
      <b-col>
        <close-button
          class="float-right"
          @close-button-click="handleCloseButtonClick"
        />
      </b-col>
    </b-row>
    <h2 style="color: whitesmoke">
      <strong>
        Generate Reports
      </strong>
    </h2>
    <b-button
        pill
        style="margin: 15px;"
        variant="outline-light"
    >
      Daily Summary
    </b-button>
    <b-button pill variant="outline-light">Medication Report</b-button>
    <b-button
        pill
        style="margin: 15px;"
        variant="outline-light"
    >
      Behavior Analysis
    </b-button>
    <hr style="background-color: whitesmoke"/>
  </div>
</template>

<script>
import CloseButton from "@/components/common/closeButton"
export default {
  name: "Display_PaneIntro",
  components: {
    CloseButton
  },
  created(){},
  mounted() {},
  props: {
    output: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input(){
      return ""
    }
  },
  methods: {
    handleGenerateClick(){
      this.$emit("generate-click", this.input)
    },
    handleCloseButtonClick(){
      this.$emit("close-button-click");
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
